import type { FaireProductEntity } from "../../entity_types/product";

export const p_baa3r8cuyx: FaireProductEntity = {
  token: "p_baa3r8cuyx",
  type: "product",
  name: "Glittery Dreamy Celestial Star-Moon Design Hair Claw Clip",
  brandToken: "b_xttg6nwn4k",
  brandName: "SoapElenGlen",
  imageUrl:
    "https://cdn.faire.com/fastly/0b81d61814214218dacc4ba54eb99f5c3c6653438625cb9f361fd7686563ee61.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dadcabce735543e473a2a4744dda70dcc5f1b74ae73e83430f280652ac45f0d5.jpeg",
    "https://cdn.faire.com/fastly/13124417ef321f5a7e6ae905f251bfc7c75bb080e8d86347e7d81de7b4ddcc3b.jpeg",
    "https://cdn.faire.com/fastly/2a805fda42da716cf84e2fadc3baac06fa7b5d757405e25b34304168bce6f9e5.jpeg",
    "https://cdn.faire.com/fastly/2cf1f55b0bb8b064ad6c0b602f0667ac1fdba3582787c3bd7689ebf5b32409df.jpeg",
    "https://cdn.faire.com/fastly/44e31b91bd28326c81f177d54f0017f3f9fb0252e64ef6944f776c5960a53769.jpeg",
    "https://cdn.faire.com/fastly/314e7ac0c3c351b42bacc64ab400cdd8d1aca7ce79eed5f8355ff27a32c43f50.jpeg",
    "https://cdn.faire.com/fastly/ceeafbf3f8627a7c356ff963a983dbdf791c4c1fc609b77963011de08b31b0a9.jpeg",
    "https://cdn.faire.com/fastly/82b3a87a4718eefec9804cc0b220830fb7f48e8da3c6d02e73a6574053394eea.jpeg",
    "https://cdn.faire.com/fastly/eb56adc389433ea74760d67acc856655bd1a357862ddff5c8159feb3ddfb9197.jpeg",
  ],
  priceDollars: 3.96,
  description:
    "🌿 Material:  Acrylic\n\n📏 Size & Weight: 9*4.5cm, 26g\n\n💖 Design Features:\n\nElevate your hairstyle with this charming celestial hair claw clip, featuring whimsical star and moon motifs! Available in varied eye-catching styles—from glittery finishes and gradient galaxy patterns to vibrant rainbow stripes—it adds a dreamy, romantic touch to any look. The sturdy claw structure ensures a secure grip, perfect for holding half-updos, low buns, or loose strands in place. Blending decorative charm with practical functionality, this clip is ideal for daily wear, dates, or casual outings.",
  tags: [],
  msrpDollars: 7.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:23.774Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
